





















































































































































































































import Vue from "vue";
import * as val from "../../base/validations";
import Api from "../../base/api.typings";
import Component from "vue-class-component";
import chamadoService from "./chamado-service";
import { Prop } from "vue-property-decorator";
import { obterDataFormatada, obterArquivosValidos, obterSituacaoDescricao } from "../../utils/utils";
import usuarioService from "../usuario/usuario-service";
import routerService from '../../base/router-service';
import { ArquivosGeral } from '../../utils/constants';
import env from '../../env/env';
import areaService from '../area-atual/area-service';
import empresaAtualService from '../empresa-atual/empresa-atual-service';
import funcionarioService from "../funcionario/funcionario-service";

@Component
export default class ChamadoDetalhar extends Vue {
    @Prop() chamadoId: number

    @Prop({ default: false }) modal: boolean;

    @Prop() fecharModal: Function;

    modalRef;

    chamado: Api.App.Server.Chamado.DetalharChamado.Dto = null;

    get carregando() {
        return !this.chamado;
    }

    obterDataFormatada = obterDataFormatada;

    usuarios: any = [];

    areaAtual: string = null;

    empresaId: string = null;

    async listarUsuario() {
        let usuario = await usuarioService.listarPorEmpresa({
            empresaId: this.empresaId,
            atribuidoA: this.chamado.atribuidoA,
        });

        let result = [];

        for (let item of usuario.itens) {
            result.push({
                id: item.id,
                nome: item.nome
            })
        }

        this.usuarios = result;
    };

    obterNomeUsuario(id: number) {
        if (!this.usuarios)
            return "";

        let usuario = this.usuarios.find(p => p.id == id);
        if (usuario) {
            return usuario.nome;
        }
    }

    interacao: Api.App.Server.Chamado.RegistrarInteracao.Command = {
        id: this.chamadoId,
        mensagem: '',
        arquivos: []
    }

    tipoArquivos = ArquivosGeral;

    atribuidoA: string = null;

    novaSituacao: Api.Common.Domain.ChamadoSituacaoEnum = null;

    novaPrioridade: Api.Common.Domain.ChamadoPrioridadeEnum = null;

    situacoes = [
        {
            nome: "Aberto", id: Api.Common.Domain.ChamadoSituacaoEnum.Aberto,
        },
        {
            nome: "Fechado", id: Api.Common.Domain.ChamadoSituacaoEnum.Fechado,
        },
        {
            nome: "Em andamento", id: Api.Common.Domain.ChamadoSituacaoEnum.EmAndamento,
        }
    ]

    prioridades = [
        {
            nome: "Alta", id: Api.Common.Domain.ChamadoPrioridadeEnum.Alta,
        },
        {
            nome: "Média", id: Api.Common.Domain.ChamadoPrioridadeEnum.Media,
        },
        {
            nome: "Baixa", id: Api.Common.Domain.ChamadoPrioridadeEnum.Baixa,
        }
    ]

    rulesInteracao = {
        $summary: [] as any[],
        mensagem: [val.required, val.maxLength(1000)]
    }

    obterSituacaoDescricao = obterSituacaoDescricao;

    setarModalRef(ref: any) {
        this.modalRef = ref;
    }

    modalFechar() {
        this.fecharModal();
    }

    obterSituacaoCor(situacao: Api.Common.Domain.ChamadoSituacaoEnum) {
        switch (+situacao) {
            case Api.Common.Domain.ChamadoSituacaoEnum.Aberto:
                return "t-chamado-situacao-aberto";
            case Api.Common.Domain.ChamadoSituacaoEnum.Fechado:
                return "t-chamado-situacao-fechado";
            case Api.Common.Domain.ChamadoSituacaoEnum.EmAndamento:
                return "t-chamado-situacao-andamento";
            default:
                break;
        }
    }

    baixarFoto(foto: string) {
        return `${env.apiUrl}/api/Chamado/BaixarArquivo?arquivo=${foto}`;
    }

    removerArquivo(arquivo: File) {
        this.interacao.arquivos = this.interacao.arquivos.filter(e => e != arquivo);
    }

    async obterChamado() {
        this.chamado = await chamadoService.detalharChamado({
            id: this.chamadoId,
            empresaId: this.empresaId,
        });
    }

    async voltarPagina() {
        await routerService.goTo('chamado-listar');
    }

    anexarDocumento() {
        if (this.$refs.arquivoFormInteracao)
            (this.$refs.arquivoFormInteracao as any).click();
    }

    arquivosChange(event) {
        let files = [];

        if (event.target.files.length > 1) {
            for (let file of event.target.files) {
                files.push(file);
            }
        } else {
            files.push(event.target.files[0]);
        }

        let arquivos = obterArquivosValidos(files, this.tipoArquivos);

        this.interacao.arquivos = [...this.interacao.arquivos, ...arquivos];
    }

    exibirDocumento($event, documentoId: string, documentoTitulo: string) {
        (this.$refs.documentoVisualizar as any).exibirDocumento(event, documentoId, documentoTitulo, this.empresaId);
    }

    registrarInteracao() {
        let formData = new FormData();

        formData.append('id', this.chamadoId.toString());

        formData.append("mensagem", this.interacao.mensagem);

        for (let arquivo of this.interacao.arquivos) {
            formData.append("arquivos[]", arquivo);
        }

        formData.append("empresaId", this.empresaId.toString());

        this.$action.processSubmit({
            action: async () => {
                await chamadoService.registrarInteracao(formData);

                await this.obterChamado();

                let form: any = this.$refs.formInteracao;

                form.reset();
            },
            form: this.$refs.formInteracao,
            rules: this.rulesInteracao
        });
    }

    obterPrioridadeDescricao(prioridade: Api.Common.Domain.ChamadoPrioridadeEnum) {
        switch (prioridade) {
            case Api.Common.Domain.ChamadoPrioridadeEnum.Alta:
                return "Alta";
            case Api.Common.Domain.ChamadoPrioridadeEnum.Media:
                return "Média";
            case Api.Common.Domain.ChamadoPrioridadeEnum.Baixa:
                return "Baixa";
            default:
                break;
        }
    }

    atribuidoChange(value) {
        this.atribuidoA = value;

        this.editarChamado();
    }

    situacaoChange(value) {
        this.novaSituacao = value;

        this.editarChamado();
    }

    prioridadeChange(value) {
        this.novaPrioridade = value;

        this.editarChamado();
    }

    async editarChamado() {
        this.$action.processSubmit({
            action: async () => {
                await chamadoService.editarChamado({
                    id: this.chamadoId,
                    atribuidoA: this.atribuidoA,
                    situacao: this.novaSituacao,
                    prioridade: this.novaPrioridade,
                    empresaId: this.empresaId,
                });
            },
            form: this.$refs.form,
            rules: this.rulesInteracao
        });
    }

    async carregarDados() {
        await this.obterChamado();
        await this.listarUsuario();
        await this.listarFuncionarios();
    }

    async beforeRouteUpdate(to, from, next) {
        await next();

        this.carregarDados();
    }

    async created() {
        this.empresaId = await empresaAtualService.obterEmpresaAtualId();
        this.areaAtual = await areaService.obterAreaPadrao();
        if (this.empresaId) {
            this.carregarDados();
        }
    }

    funcionario: any[] = [];

    async listarFuncionarios() {
        let funcionario = await funcionarioService.listarPorEmpresa({
            empresaId: this.empresaId
        });

        let result = [];

        for (let item of funcionario.itens) {
            result.push({
                id: item.id,
                nome: item.nome
            })
        }

        this.funcionario = result;
    }

    obterNomeFuncionario(id: number) {
        if (!this.funcionario)
            return "";

        let usuario = this.funcionario.find(p => p.id == id);
        if (usuario) {
            return usuario.nome;
        }
    }
}
